module.exports = __webpack_public_path__ + "img/icon_map_37_on_101.fc2ad5a8.png";